<template>
  <MarketingVideo
    v-if="videoSource.isSelfHosted"
    :is-mobile
    :poster="videoSource.poster"
    :product-name
    :sources="videoSource.sources"
    :title="videoSource.title"
    @click="emit('click')"
    @start="emit('start')"
  />
  <YoutubeVideo
    v-else
    :aria-label
    :is-mobile
    @click="emit('click')"
    @start="emit('start')"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import YoutubeVideo from '~/scopes/product-core/components/presentationals/GalleryNew/components/YoutubeVideo/YoutubeVideo.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

import MarketingVideo from './components/MarketingVideo/MarketingVideo.vue'
import { useGalleryVideoSource } from './components/MarketingVideo/composables/useGalleryVideoSource'

defineProps<{
  isMobile: boolean
  ariaLabel?: string
}>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'start'): void
}>()

const videoSource = useGalleryVideoSource()

const { data: productResponse } = useFetchProduct()
const productName = computed(() => productResponse.value?.model)
</script>
